import { detect } from "detect-browser"
import { useEffect } from "react"
import { useDevice } from "src/hooks/device/useDevice"
import { useUpdateDevice } from "src/hooks/device/useUpdateDevice"

export function DeviceContext() {
  const { data: device } = useDevice()
  const updateDevice = useUpdateDevice()

  useEffect(
    () => {
      if (!device || !updateDevice) {
        return
      }

      const version = process.env.REACT_APP_SOFTWARE_VERSION

      const browser = detect()
      const subtype = browser
        ? `${browser.name} ${browser.version}`
        : "unknown"

      if (
        version !== device.version ||
        subtype !== device.device_subtype
      ) {
        void updateDevice({
          id: device.id,
          version,
          device_subtype: subtype,
        })
      }
    },
    [
      device,
      updateDevice,
    ],
  )

  return null
}
